import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import IncorrectPtAdmittedComponentsStep1Part1 from "./incorrect-pt-admitted-components-step1-parts/incorrect-pt-admitted-components-step1-part1";

export default class IncorrectPtAdmittedComponentsStep1Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: IncorrectPtAdmittedComponentsStep1ComponentMainConfig) {
		let context = this;
		context._parts.push(new IncorrectPtAdmittedComponentsStep1Part1(context.config.scenario, () => {
			config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface IncorrectPtAdmittedComponentsStep1ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: IncorrectPtAdmittedComponentsStep1ComponentPart1Config;
	onDone: () => void;
}

export interface IncorrectPtAdmittedComponentsStep1ComponentPart1Config extends GeneralPartConfig {
	chapter: () => string;
}